import { DateTime, Duration } from 'luxon';

export const dateTimeFormat = 'yyyy-MM-dd HH:mm:ss';

/** Parse and output dates like "Thursday, May 22, 2025" */
export const raTimelineLabelToDate = (label: string): string => {
  const date = DateTime.fromFormat(label, 'DDDD');
  return date.isValid ? date.toFormat('yyyy-MM-dd') : '';
};

/** Parse and output timestamps like 1622548800000 */
export const timestampToDateTime = (timestamp: number): string => {
  const date = DateTime.fromMillis(timestamp);
  return date.isValid ? date.toFormat('yyyy-MM-dd HH:mm:ss') : '';
};

/** Parse and output ISO 8601 strings like "2025-05-22T14:00:00Z" */
export const isoToDateTime = (isoString: string): string => {
  const date = DateTime.fromISO(isoString);
  return date.isValid ? date.toFormat('yyyy-MM-dd HH:mm:ss') : '';
};

/** Parse and output ISO 8601 strings as time only like "14:00:53" */
export const isoToTime = (isoString: string): string => {
  const date = DateTime.fromISO(isoString);
  return date.isValid ? date.toFormat('HH:mm:ss') : '';
};

/** Parse and output ISO 8601 strings as date only like "2025-05-22" */
export const isoToDate = (isoString: string): string => {
  const date = DateTime.fromISO(isoString);
  return date.isValid ? date.toFormat('yyyy-MM-dd') : '';
};

/** Calculate duration between two ISO 8601 timestamps and format as "hh:mm:ss" */
export const isoDuration = (startIso: string, endIso: string): string => {
  const start = DateTime.fromISO(startIso);
  const end = DateTime.fromISO(endIso);
  if (!start.isValid || !end.isValid) return '';
  return end.diff(start).toFormat('hh:mm:ss');
};

/** Convert seconds to duration format "hh:mm:ss" */
export const secondsToDuration = (seconds: number | null | undefined): string => {
  if (seconds == null) return '';
  const duration = Duration.fromObject({ seconds });
  return duration.toFormat('hh:mm:ss');
};
